// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"e264e045","710":"9e831bb6"}[chunkId] + ".chunk.css";
};